import TYPES from './types.json';
import new_ from './new.json';
import old from './old.js';
import mixed from './mixed.js';
export var SPECS = {
  new: new_,
  old: old,
  mixed: mixed
};
export { TYPES };